export function setBrowserUnload(show) {
    if (show) {
        window.onbeforeunload = () => {
            return 'x';
        }
    } else {
        window.onbeforeunload = null;
    }
}

export function getBrowserLanguage() {
    return navigator.language || navigator.userLanguage;
}

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export function delay(fn, ms, ...args) {
    const timerId = setTimeout(() => {
        fn(...args);
    }, ms);

    return {
        cancel: () => clearTimeout(timerId),
        id: timerId
    };
}

// Returns true if it's Mac operating system 
export function isMacOS() { 
    return window.navigator.platform.match("Mac");
}

export function isBrowserLocalUrl(url) {
    return url && url.startsWith("blob");
}

export function getVideoDuration(url, onSuccess) {
    var video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = function() {
        onSuccess(video.duration);
    }

    video.src = url;
}

export function isSafariBrowser() {
    return navigator.vendor 
        && navigator.vendor.indexOf('Apple') > -1 
        && navigator.userAgent 
        && navigator.userAgent.indexOf('CriOS') == -1 
        && navigator.userAgent.indexOf('FxiOS') == -1;
}

export function resetScroll() {
    window.scrollTo(0, 0);
}